export function getNetworkImage(url: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    if (!/^http(s)?:\/\//.test(url)) {
      reject(new Error('url不合法'));
    }
    const img = document.createElement('img');
    img.setAttribute('crossOrigin', 'anonymous');
    img.src = url;
    img.onload = () => {
      if (!img.complete) {
        reject(new Error('图片加载出现问题'));
      }
      resolve(img);
    };
    img.onerror = (error) => {
      reject(error);
    };
  });
}

export function circleImg(ctx: CanvasRenderingContext2D, img: HTMLImageElement, x: number, y: number, r: number) {
  ctx.save();
  const d = 2 * r;
  const cx = x + r;
  const cy = y + r;
  ctx.arc(cx, cy, r, 0, 2 * Math.PI);
  ctx.arc(cx, cy, r + 1, 0, 2 * Math.PI);
  ctx.stroke();
  ctx.strokeStyle = '#979797';
  ctx.clip();
  ctx.drawImage(img, x, y, d, d);
  ctx.restore();
}

/**
 * 微信端文章和产品  富文本中  的图片点击预览 (需求过滤富文本中的图片链接问题)
 * @param  {[type]} e
 * @return {[type]}   [description]
 */
export const imagePreview = (e: Event) => {
  let hasPreview = false;
  function find(dom, callback) {
    if (dom.parentNode) {
      if (dom.parentNode !== document && !!dom.parentNode.getAttribute('href')) {
        hasPreview = true;
        callback();
      }
      find(dom.parentNode, callback); // dom.parentNode作为子素向上查找它的父元素
    } else {
      callback();
      console.log('end');
    }
  }
  find(e.target, function () {
    if (!hasPreview) {
      if (e.target.nodeName === 'IMG') {
        const str = e.target.currentSrc;
        // 排除gif图部分
        if (str.substr(str.length - 4, str.length) === '.gif') {
          return false;
        }
        WeixinJSBridge.invoke(
          'imagePreview',
          {
            urls: [str],
            current: str,
          },
          function (res) {
            console.log(res.err_msg);
          }
        );
      } else {
        return false;
      }
    }
  });
};

/**
 * api监测图片在视图区域进行替换url，实现懒加载    父容器加id   lazyLoadImgContent
 * @return {[type]} [description]
 */
export const lazyLoadImg = () => {
  // 监测高度
  const height = document.documentElement.clientHeight;
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRect.top <= height) {
          const img = new Image(); // 创建一个Image对象，实现图片的预下载
          img.onload = function () {
            img.onload = null;
            // 延迟展示loading
            setTimeout(() => {
              /* 替换属性 */
              entry.target.src = entry.target.dataset.src;
              observer.unobserve(entry.target);
            }, 100);
          };
          img.src = entry.target.src;
        }
      });
    },
    { rootMargin: `${0}px 0px 0px 0px` }
  );
  Array.prototype.forEach.call(document.querySelectorAll('#lazyLoadImgContent img'), (ele) => {
    observer.observe(ele);
  });
};

/**
 * 剔除监听
 * @return {[type]} [description]
 */
export const removerObserve = () => {
  const observer = new IntersectionObserver((entries, observer) => {});
  Array.prototype.forEach.call(document.querySelectorAll('#lazyLoadImgContent img'), (ele) => {
    observer.unobserve(ele);
  });
};

// 判断某元素节点下全部图片是否加载成功
export const allImgLoaded = async (element: HTMLElement) => {
  let result = false;
  const imgs = element.getElementsByTagName('img');
  const eleArr = Array.prototype.slice.call(imgs);
  const allPromise = eleArr.map((img, index) => {
    return new Promise((resolve, reject) => {
      const url = imgs[index].getAttribute('src');
      const newImg = new Image();
      newImg.onload = () => {
        resolve();
      };
      newImg.onerror = () => {
        reject(new Error('图片加载失败'));
      };
      newImg.src = url;
    });
  });

  await Promise.all(allPromise).then(() => {
    result = true;
  });
  return result;
};
